// CoreSolutions.js

import React from 'react'
import styles from "./CoreSolutions.module.scss"
import Pillar from '../LowLevel/Pillar/Pillar'

export default function CoreSolutions() {
  const coreItems = [
    {
      img: "/icons/handshake.svg",
      title: "Lead Generation",
      desc: "We specialize in generating high-quality, intent-driven leads across a range of verticals. By tapping into the right channels, we deliver leads that convert — not just click."
    },
    {
      img: "/icons/marketing.svg",
      title: "Performance Marketing",
      desc: "Every dollar should drive results. Our performance-based campaigns are built to scale and focused on outcomes like sales, signups, or inquiries, so you only pay for what works."
    },
    {
      img: "/icons/data.svg",
      title: "Data & Analytics",
      desc: "Data is at the heart of what we do. We track and optimize every touchpoint to give you transparent insights, audience intelligence, and continual performance improvement."
    },
  ]

  return (
    <div className={styles.coreParent} id="solutions">
      <h2>Our Core Solutions</h2>
      <div className={styles.corePillars}>
        <div className='row'>
          {coreItems.map((item, index) => (
            <div className="col-lg-4 col-md-6 col-12" key={index}>
              <Pillar item={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
